// extracted by mini-css-extract-plugin
export default {"card":"HeroCard_card__RKTYD","tileGrid":"HeroCard_tileGrid__ojtRh","circle":"HeroCard_circle__5Tngg","title":"HeroCard_title__TNmCM","body":"HeroCard_body__y8YWO"};